import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../src/styles/main.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
// import reportWebVitals from './reportWebVitals';

// import UserProvider from "./context/UserProvider"; //Ignorar por el momento
import store, { persistor } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <UserProvider> */}
        <App />
        {/* </UserProvider> */}
      </PersistGate>
    </Provider>
  </>
);
